import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
    const navigate = useNavigate()
  return (
    <>
    <div className="notFoundPage">
    <div>
      <div className="heading">Ooops... Page not found!</div>
      <button
        className="btnPrimaryBack"
        onClick={() => navigate("/")}
      >
        Back to Home
      </button>
    </div>
  </div>
    </>
  )
}

export default NotFound